import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { RelatedReads } from "@/components/seo/RelatedReads";
import { getPostsBySlugs } from "@/content/blogPosts";
import { Footer } from "@/components/layout/Footer";
import { SEOContentBlock } from "@/components/seo/SEOContentBlock";
import { Testimonials } from "@/components/seo/Testimonials";
import { seoCopy } from "@/content/seoCopy";
import {
  HeroSection,
  PhotoGallerySection,
  ProblemSection,
  ImageBreakSection,
  HowTheDayFlowsSection,
  DifferentiatorsSection,
  ExperienceOptionsSection,
  ComparisonSection,
  LocationMapSection,
  FinalCTASection,
} from "@/components/home/HomeSections";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="River Cabanas & Tubing in New Braunfels | Son's"
        description="Private riverside cabanas, family tubing & glamping on the Guadalupe River in New Braunfels. Float back to your cabana — not a parking lot. Book today!"
        canonical="/"
        ogImage="/og/home.jpg"
        schemaJson={[
          {
            "@context": "https://schema.org",
            "@type": "LodgingBusiness",
            "@id": "https://sonsguadalupe.com/#lodging",
            name: "Son's Guadalupe",
            description:
              "Private riverside cabanas, tubing, and glamping on the Guadalupe River in New Braunfels, TX. 22 private cabanas with grills, picnic tables, parking, and direct river access.",
            url: "https://sonsguadalupe.com",
            logo: "https://sonsguadalupe.com/og-image.png",
            image: "https://sonsguadalupe.com/og/home.jpg",
            telephone: "+1-877-577-7667",
            email: "info@sonsgetaways.com",
            priceRange: "$69-$899",
            currenciesAccepted: "USD",
            paymentAccepted: "Credit Card",
            address: {
              "@type": "PostalAddress",
              streetAddress: "7308 River Road",
              addressLocality: "New Braunfels",
              addressRegion: "TX",
              postalCode: "78132",
              addressCountry: "US",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 29.8694,
              longitude: -98.1972,
            },
            hasMap: "https://www.google.com/maps/place/Son's+Guadalupe",
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ],
                opens: "09:00",
                closes: "19:00",
              },
            ],
            amenityFeature: [
              "Private river access",
              "Riverside cabanas",
              "Charcoal grills",
              "Picnic tables",
              "Dedicated parking",
              "Restrooms",
              "Wi-Fi",
              "Tubing",
              "Glamping bell tents",
              "Fire pits",
            ].map((name) => ({
              "@type": "LocationFeatureSpecification",
              name,
              value: true,
            })),
            areaServed: [
              { "@type": "City", name: "New Braunfels" },
              { "@type": "City", name: "San Antonio" },
              { "@type": "City", name: "Austin" },
              { "@type": "State", name: "Texas" },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "TouristAttraction",
            name: "Son's Guadalupe",
            description:
              "Private riverside cabanas, tubing, and glamping on the Guadalupe River in New Braunfels, TX.",
            url: "https://sonsguadalupe.com",
            image: "https://sonsguadalupe.com/og/home.jpg",
            telephone: "+1-877-577-7667",
            address: {
              "@type": "PostalAddress",
              streetAddress: "7308 River Road",
              addressLocality: "New Braunfels",
              addressRegion: "TX",
              postalCode: "78132",
              addressCountry: "US",
            },
          },
        ]}
      />
      <Header />
      <main>
        <HeroSection />
        <PhotoGallerySection />
        <ExperienceOptionsSection />
        <ProblemSection />
        <ImageBreakSection />
        <HowTheDayFlowsSection />
        <DifferentiatorsSection />
        <Testimonials />
        <ComparisonSection />
        <LocationMapSection />
        <FinalCTASection />
      </main>
      <SEOContentBlock {...seoCopy.index} />
      <RelatedReads posts={getPostsBySlugs(["memorial-day-weekend-guadalupe-river", "tubing-guadalupe-river-new-braunfels", "cabana-rentals-price-whats-included"])} heading="From our blog" />
      <Footer />
    </div>
  );
};

export default Index;
